"use strict";
// знаходимо елемент .logo
var logo = document.querySelector(".logo");
// функція для повідомлення про успіх
function successHandler() {
    var message = document.createElement("div");
    message.className = "message";
    message.textContent = "Promise was resolved!";
    document.body.append(message);
}
// функція для повідомлення про помилку
function errorHandler() {
    var message = document.createElement("div");
    message.className = "message error-message";
    message.textContent = "Promise was rejected!";
    document.body.append(message);
}
// Promise 1 (виконується після кліку)
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
// Promise 2 (відхиляється через 3 секунди)
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise rejected"));
    }, 3000);
});
// обробники
promise1.then(successHandler).catch(errorHandler);
promise2.then(successHandler).catch(errorHandler);

//# sourceMappingURL=index.81067a1a.js.map
